import i18n from 'i18next';
import { getIsLoadingServiceByParams, getTravellersMap } from '../../../utils';
import { GdsServiceVipSubType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { LoadingServiceType } from '../../../Checkout/store/loadingServicesParams/reducers';
import { getAeroexpressName } from './getAeroexpressName';
import { getRelatedServiceType } from './getRelatedServiceType';
import { includedOptionItemFactory } from './includedOptionItemFactory';
import { additionalOptionItemFactory } from './additionalOptionItemFactory';
import { optionGroupsFactory } from './optionGroupsFactory';
export function getAggregatedSummaryServices(config, additionalServices, segments, travellers, selectedServices, segmentsGroupsCount, isConfirmed, priceToPay, loadingServicesParams = {
    id: [],
    rfisc: [],
    subType: [],
    type: []
}) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const gdsServices = (_b = (_a = additionalServices.gdsServices) === null || _a === void 0 ? void 0 : _a.services) !== null && _b !== void 0 ? _b : [];
    const travellersMap = getTravellersMap(travellers);
    const gdsServicesMap = new Map(gdsServices.map(service => [service.id, service]));
    const servicesProductsMap = new Map();
    const segmentsCount = segments.length;
    const summaryItemsByTypes = {
        Seat: [],
        Baggage: [],
        BaggageDelivery: [],
        Animal: [],
        Meal: [],
        BusinessLounge: [],
        PriorityBoarding: [],
        RefundableTicket: [],
        Insurance: [],
        Aeroexpress: [],
        Transfer: [],
        Loyalty: [],
        CapsuleHotel: [],
        Upgrade: [],
        Sms: [],
        Misc: []
    };
    // Insurance services
    if ((_d = (_c = additionalServices.insurances) === null || _c === void 0 ? void 0 : _c.selectedInsurances) === null || _d === void 0 ? void 0 : _d.length) {
        const availableInsuranceCodes = new Set((_g = (_f = (_e = additionalServices.insurances) === null || _e === void 0 ? void 0 : _e.insurancePrograms) === null || _f === void 0 ? void 0 : _f.map(insurance => insurance.code)) !== null && _g !== void 0 ? _g : []);
        const isLoading = getIsLoadingServiceByParams(loadingServicesParams, { type: LoadingServiceType.Insurance }, [
            'type'
        ]);
        const items = [];
        additionalServices.insurances.selectedInsurances.forEach(selectedInsurance => {
            var _a;
            const insuranceCode = selectedInsurance.insuranceProgram.code;
            if (availableInsuranceCodes.has(insuranceCode)) {
                const included = !!selectedInsurance.policyUrl || (isConfirmed && !((_a = priceToPay === null || priceToPay === void 0 ? void 0 : priceToPay.insurance) === null || _a === void 0 ? void 0 : _a.amount));
                items.push({
                    id: insuranceCode,
                    name: selectedInsurance.insuranceProgram.name,
                    passengerName: selectedInsurance.passengerName,
                    price: selectedInsurance.insuranceProgram.totalPrice,
                    passengerPrice: selectedInsurance.passengerPrice,
                    downloadUrl: included ? selectedInsurance.policyUrl : null,
                    allPassengersDownloadUrls: additionalServices.insurances.selectedInsurances
                        .filter(insurance => { var _a; return ((_a = insurance.insuranceProgram) === null || _a === void 0 ? void 0 : _a.code) === insuranceCode && !!insurance.policyUrl; })
                        .map(insurance => insurance.policyUrl),
                    deleteMeta: !included ? { code: insuranceCode } : null,
                    included,
                    isLoading
                });
            }
        });
        if (items.length) {
            summaryItemsByTypes.Insurance.push({ items });
        }
    }
    // Transfer services
    if ((_k = (_j = (_h = additionalServices.transfer) === null || _h === void 0 ? void 0 : _h.aeroexpress) === null || _j === void 0 ? void 0 : _j.selectedTrips) === null || _k === void 0 ? void 0 : _k.length) {
        const isLoading = getIsLoadingServiceByParams(loadingServicesParams, { type: LoadingServiceType.Transfer }, [
            'type'
        ]);
        additionalServices.transfer.aeroexpress.selectedTrips.forEach(selectedTrip => {
            summaryItemsByTypes.Aeroexpress.push({
                header: i18n.t('All passengers', { ns: 'Checkout' }),
                items: [
                    {
                        id: selectedTrip.id,
                        name: getAeroexpressName(selectedTrip),
                        price: selectedTrip.price,
                        deleteMeta: { tripId: selectedTrip.id },
                        isLoading
                    }
                ]
            });
        });
    }
    const optionsItemsMap = {};
    // Included services
    travellers.forEach(traveller => {
        var _a, _b, _c, _d, _e;
        const travellerId = traveller.id;
        if (!optionsItemsMap[travellerId]) {
            optionsItemsMap[travellerId] = {};
        }
        (_c = (_b = (_a = traveller.services) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.forEach(service => {
            var _a;
            const key = `${service.serviceId}/${service.segmentIds.join('/')}`;
            servicesProductsMap.set(key, [...((_a = servicesProductsMap.get(key)) !== null && _a !== void 0 ? _a : []), ...service.products]);
        });
        const includedServicesMap = new Map();
        (_e = (_d = traveller.services) === null || _d === void 0 ? void 0 : _d.brandIncludedServices) === null || _e === void 0 ? void 0 : _e.services.forEach(includedService => {
            var _a, _b;
            const key = `${(_b = (_a = includedService.service) === null || _a === void 0 ? void 0 : _a.rfisc) !== null && _b !== void 0 ? _b : includedService.serviceId}/${includedService.count}`;
            const includedServicesBySegment = includedServicesMap.get(key);
            includedService.segmentIds.map(segmentId => {
                if (includedServicesBySegment) {
                    includedServicesBySegment.set(segmentId, includedService);
                }
                else {
                    includedServicesMap.set(key, new Map([[segmentId, includedService]]));
                }
            });
        });
        includedServicesMap.forEach(includedServices => {
            const segmentIds = [...includedServices.keys()];
            const isAllSegments = segmentIds.length === segmentsCount;
            (isAllSegments ? ['allSegments'] : segmentIds).map(key => {
                var _a;
                const includedService = (_a = includedServices.get(key)) !== null && _a !== void 0 ? _a : [...includedServices.values()][0];
                const type = includedService.service.type;
                const gdsServiceType = getRelatedServiceType(type);
                const productsKey = `${includedService.serviceId}/${includedService.segmentIds.join('/')}`;
                const products = servicesProductsMap.get(productsKey);
                const includedItem = includedOptionItemFactory({
                    key,
                    travellerId,
                    segmentsGroupsCount,
                    segments,
                    products,
                    includedService
                });
                if (includedItem) {
                    if (!optionsItemsMap[travellerId][key]) {
                        optionsItemsMap[travellerId][key] = {};
                    }
                    if (!optionsItemsMap[travellerId][key][gdsServiceType]) {
                        optionsItemsMap[travellerId][key][gdsServiceType] = [];
                    }
                    optionsItemsMap[travellerId][key][gdsServiceType].push(includedItem);
                }
            });
        });
    });
    // Selected services
    const selectedServicesMap = new Map();
    for (const travellerId in selectedServices) {
        if (!optionsItemsMap[travellerId]) {
            optionsItemsMap[travellerId] = {};
        }
        for (const serviceId in selectedServices[travellerId]) {
            const services = selectedServices[travellerId][serviceId];
            if (!services) {
                continue;
            }
            const gdsService = gdsServicesMap.get(serviceId);
            const isRefundableTicketService = (gdsService === null || gdsService === void 0 ? void 0 : gdsService.subType) ===
                GdsServiceVipSubType.RefundableTicket;
            services.forEach(service => {
                var _a;
                const serviceRfiscOrId = (_a = gdsService === null || gdsService === void 0 ? void 0 : gdsService.rfisc) !== null && _a !== void 0 ? _a : serviceId;
                const keyValues = [serviceRfiscOrId, travellerId];
                const isSeatType = service.servicePayload.type === OrderAdditionalServiceGdsServiceServiceType.Seat;
                const separateBySegment = isSeatType;
                if (separateBySegment) {
                    const segmentId = service.segments[0];
                    keyValues.push(segmentId);
                }
                else if (!isRefundableTicketService) {
                    let count = service.number;
                    if ('confirmedCount' in service.servicePayload &&
                        typeof service.servicePayload.confirmedCount === 'number') {
                        count = service.servicePayload.confirmedCount;
                    }
                    keyValues.push(count.toString());
                }
                const key = keyValues.join('/');
                const selectedService = Object.assign(Object.assign({}, service), { travellerId, gdsService });
                service.segments.map(segmentId => {
                    const selectedServicesBySegment = selectedServicesMap.get(key);
                    if (selectedServicesBySegment) {
                        selectedServicesBySegment.set(segmentId, selectedService);
                    }
                    else {
                        selectedServicesMap.set(key, new Map([[segmentId, selectedService]]));
                    }
                });
            });
        }
    }
    selectedServicesMap.forEach(selectedServices => {
        const segmentIds = [...selectedServices.keys()];
        const selectedSegmentsCount = segmentIds.length;
        const isAllSegments = selectedSegmentsCount === segmentsCount;
        const serviceProductsMap = new Map();
        [...selectedServices.values()].forEach(service => {
            var _a;
            const key = `${service.servicePayload.id}/${service.segments.join('/')}`;
            const products = (_a = servicesProductsMap.get(key)) !== null && _a !== void 0 ? _a : [];
            products.forEach(product => {
                serviceProductsMap.set(product.id, product);
            });
        });
        const serviceProducts = [...serviceProductsMap.values()];
        (isAllSegments ? ['allSegments'] : segmentIds).forEach(key => {
            var _a, _b, _c, _d, _e, _f;
            const selectedService = (_a = selectedServices.get(key)) !== null && _a !== void 0 ? _a : [...selectedServices.values()][0];
            const serviceId = selectedService.servicePayload.id;
            const travellerId = selectedService.travellerId;
            const gdsService = selectedService.gdsService;
            const type = (_c = (_b = selectedService.servicePayload) === null || _b === void 0 ? void 0 : _b.type) !== null && _c !== void 0 ? _c : gdsService === null || gdsService === void 0 ? void 0 : gdsService.type;
            const subType = (_d = gdsService === null || gdsService === void 0 ? void 0 : gdsService.baggageType) !== null && _d !== void 0 ? _d : gdsService === null || gdsService === void 0 ? void 0 : gdsService.subType;
            const gdsServiceType = getRelatedServiceType(type, subType, {
                isAnimalAvailable: (_f = (_e = config.global) === null || _e === void 0 ? void 0 : _e.servicesAvailable) === null || _f === void 0 ? void 0 : _f.animal
            });
            const isLoading = getIsLoadingServiceByParams(loadingServicesParams, { id: serviceId, type, subType });
            const additionalItem = additionalOptionItemFactory({
                key,
                travellerId,
                gdsServiceType,
                segmentsGroupsCount,
                segments,
                isLoading,
                selectedService,
                selectedSegmentsCount,
                products: serviceProducts,
                gdsServiceRfisc: gdsService === null || gdsService === void 0 ? void 0 : gdsService.rfisc
            });
            if (!!additionalItem) {
                if (!optionsItemsMap[travellerId][key]) {
                    optionsItemsMap[travellerId][key] = {};
                }
                if (!optionsItemsMap[travellerId][key][gdsServiceType]) {
                    optionsItemsMap[travellerId][key][gdsServiceType] = [];
                }
                optionsItemsMap[travellerId][key][gdsServiceType].push(...(Array.isArray(additionalItem) ? additionalItem : [additionalItem]));
            }
        });
    });
    const optionItemsByKey = new Map();
    for (const travellerId in optionsItemsMap) {
        for (const segmentKey in optionsItemsMap[travellerId]) {
            for (const type in optionsItemsMap[travellerId][segmentKey]) {
                const gdsServiceType = type;
                const items = optionsItemsMap[travellerId][segmentKey][gdsServiceType];
                if (!(items === null || items === void 0 ? void 0 : items.length)) {
                    continue;
                }
                const optionGroup = optionGroupsFactory({
                    items,
                    gdsServiceType,
                    segments,
                    key: segmentKey,
                    traveller: travellersMap.get(travellerId)
                });
                if (!Array.isArray(optionGroup) &&
                    (gdsServiceType === 'Seat' || gdsServiceType === 'Meal' || gdsServiceType === 'Sms')) {
                    let key = travellerId;
                    if (gdsServiceType === 'Sms') {
                        key = `${optionGroup.items[0].id}/${gdsServiceType}`;
                    }
                    const optionItemsByServiceKey = optionItemsByKey.get(key);
                    if (optionItemsByServiceKey) {
                        const gdsServiceOptionItems = optionItemsByServiceKey.get(gdsServiceType);
                        if (gdsServiceOptionItems) {
                            gdsServiceOptionItems.items.push(...optionGroup.items);
                        }
                        else {
                            optionItemsByServiceKey.set(gdsServiceType, optionGroup);
                        }
                    }
                    else {
                        optionItemsByKey.set(travellerId, new Map([[gdsServiceType, optionGroup]]));
                    }
                    continue;
                }
                summaryItemsByTypes[gdsServiceType].push(...(Array.isArray(optionGroup) ? optionGroup : [optionGroup]));
            }
        }
    }
    if (optionItemsByKey.size) {
        optionItemsByKey.forEach(optionItemsByGdsServiceType => {
            optionItemsByGdsServiceType.forEach((group, gdsServiceType) => {
                group.items.sort((a, b) => {
                    const aPriority = (a.included ? 1 : 0) + (a.segment === 'allSegments' ? 1 : 0);
                    const bPriority = (b.included ? 1 : 0) + (b.segment === 'allSegments' ? 1 : 0);
                    return bPriority - aPriority;
                });
                summaryItemsByTypes[gdsServiceType].push(group);
            });
        });
    }
    return summaryItemsByTypes;
}
